import React from 'react';
import styled from 'App/styled';
import { CheckBoxProps } from '../types';

const Wrapper = styled.div`
  border: none;
  // padding-left: 8px;
  display: flex;
  align-items: center;
  input {
    z-index: -1;
    opacity: 0;
    position: absolute;
  }
  .control-value {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.spacing80};
    .title {
      ${({ theme }) => theme.typography.bodyMedium};
      text-transform: capitalize;
    }
    .count {
      ${({ theme }) => theme.typography.bodyMedium};
      color: #5c6874;
    }
  }
  .control {
    padding-top: 8px;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    flex-grow: 1;
    cursor: pointer;
    ${({ theme }) => theme.typography.bodyMedium};
    color: #003125;
    justify-content: space-between;
  }
  .palettes {
    display: inline-block;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border-radius: 50%;
    margin-right: 8px;
    border: 1px dashed rgba(0, 12, 204, 0.2);
  }
  .control-indicator {
    height: 20px;
    width: 20px;
    border: 2px solid #00132512;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.colors.snow300};
    border-radius: 3px;
    &.checkbox,
    &.radio {
      border-radius: 3px;
      &.active::after {
        content: '';
        width: 3px;
        height: 8px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        margin-bottom: 2px;
      }
    }
    &.radio {
      border-radius: 50%;
    }
    &.active {
      background: ${(props) => props.theme.brandPrimary};
      border: none;
    }
  }
`;
const selectColor = (colorCode: string, name: string) => {
  if (name === 'Multi-Color') {
    return '';
  }
  if (colorCode) {
    return colorCode;
  }
  return name;
};

const CheckBox = (props: CheckBoxProps) => {
  const {
    data,
    handleFilterChange,
    isSelected,
    type = 'checkbox',
    isColor = false,
  } = props;
  const { name, id, count, color_code: colorCode } = data;
  const controlIndicatorClass = `control-indicator ${type} ${
    isSelected ? 'active' : ''
  }`;
  const handleClick = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    handleFilterChange(data, e?.currentTarget?.checked);
    e.stopPropagation;
  };
  const inputId = `${type}_${name}_${id}`;
  return (
    <Wrapper className="control-box">
      <input
        id={inputId}
        type={type}
        onClick={handleClick}
        checked={isSelected}
      />
      <label
        className={`control control-${type}`}
        htmlFor={`${type}_${name}_${id}`}
      >
        <div className="control-value">
          {isColor && (colorCode || name) && (
            <span
              className="palettes"
              style={{
                background: selectColor(colorCode, name),
              }}
            />
          )}
          <span className="title">{name}</span>
          {count && <span className="count">{count}</span>}
        </div>
        <div className={controlIndicatorClass} />
      </label>
    </Wrapper>
  );
};

export default CheckBox;
